export default [
	{
		id: 4,
		name: "React",
		level: "80",
	},
	{
		id: 3,
		name: "JavaScript",
		level: "90",
	},
	{
		id: 9,
		name: "Git",
		level: "80",
	},
	{
		id: 10,
		name: "SQL",
		level: "60",
	},
	{
		id: 1,
		name: "HTML",
		level: "90",
	},
	{
		id: 2,
		name: "CSS",
		level: "90",
	},

	{
		id: 6,
		name: "Node",
		level: "40",
	},
	{
		id: 7,
		name: "Python",
		level: "30",
	},

	{
		id: 11,
		name: "MongoDB",
		level: "40",
	},
	{
		id: 12,
		name: "Docker",
		level: "10",
	},
];
